import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const MainButton = ({
  text,
  textClr,
  textBold,
  textSize,
  bg = "transparent",
  borderClr,
  icon,
  disabled,
  type = "button",
  className,
  loading,
  onClick = () => {},
}) => {
  return (
    <button
      type={type}
      className={`main-btn d-flex justify-content-center align-items-center gap-1 gap-md-2 h-auto outline-none shadow-none ${
        disabled ? "main-btn--disabled" : ""
      } ${
        textBold ? "font--bold" : ""
      } fsize--${textSize} text--${textClr} bg--${bg} ${
        borderClr ? `border--${borderClr}` : "border-0"
      }  ${className}`}
      onClick={() => {
        if (loading || disabled) return;
        onClick();
      }}
      disabled={disabled || loading}
    >
      {icon ? icon : ""}
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 18,
                color: bg === "transparent" ? "grey" : "white",
              }}
              spin
            />
          }
        />
      ) : (
        ""
      )}
      <span>{text}</span>
    </button>
  );
};

export default MainButton;
